import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Modal, Table, Form, Col, Row } from "react-bootstrap";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";

const BASE_API_URL = process.env.REACT_APP_API_URL;

const EmailList = () => {
    const [showModal, setShowModal] = useState(false);
    const [emailListData, setEmailListData] = useState([]);

    const [emailListName, setListName] = useState("");
    const [marketingFor, setMarketingFor] = useState("");
    const [createdAt, setDate] = useState("");
   // const [emails, setEmails] = useState([]);
    const [editId, setEditId] = useState(null);
    // const [googleSheetUrl, setGoogleSheetUrl] = useState("");
    // New state — holds exactly what the user is typing, untouched
const [emailsText, setEmailsText] = useState("");

// Derive the actual array only when you need it (e.g. for the count, or on save)
const emails = emailsText
    .split(",")
    .map((e) => e.trim())
    .filter((e) => e.length > 0);

    useEffect(() => {
        fetchEmailList();
    }, []);

    const fetchEmailList = async () => {
        try {
            const res = await axios.get(`${BASE_API_URL}/getEmailList`);
            setEmailListData(res.data || []);
        } catch (error) {
            console.error(error);
        }
    };

    // ================= EXCEL FILE READ =================
    const handleExcelUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = (evt) => {
            try {
                const data = evt.target.result;
                const workbook = XLSX.read(data, { type: "binary" });

                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];

                const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                let extractedEmails = [];

                rows.forEach((row) => {
                    row.forEach((cell) => {
                        if (
                            typeof cell === "string" &&
                            /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cell.trim())
                        ) {
                            extractedEmails.push(cell.trim());
                        }
                    });
                });

                // remove duplicates
                extractedEmails = [...new Set(extractedEmails)];

                // ❌ NO EMAILS FOUND
                if (extractedEmails.length === 0) {
                    Swal.fire({
                        icon: "error",
                        title: "No Emails Found",
                        text: "The uploaded file does not contain any valid email addresses.",
                    });
                    return;
                }

                // ✅ SUCCESS
                setEmailsText(extractedEmails.join(", "));

                Swal.fire({
                    icon: "success",
                    title: "Emails Imported",
                    text: `${extractedEmails.length} emails loaded`,
                    timer: 1500,
                    showConfirmButton: false,
                });

            } catch (error) {
                console.error("Excel parsing error:", error);

                Swal.fire({
                    icon: "error",
                    title: "Invalid File",
                    text: "Failed to read the file. Please upload a valid Excel/CSV file.",
                });
            }
        };

        reader.readAsBinaryString(file);
    };

    // ================= GOOGLE SHEET IMPORT =================
    // const handleGoogleSheetImport = async () => {
    //     if (!googleSheetUrl) return;


    //     try {
    //         const csvUrl = convertGoogleSheetUrl(googleSheetUrl);
    //         const res = await axios.get(csvUrl);
    //         const csv = res.data;

    //         const extractedEmails = csv
    //             .split(/,|\n/)
    //             .map(e => e.trim())
    //             .filter(e => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e));

    //         setEmails([...new Set(extractedEmails)]);
    //         setGoogleSheetUrl("");
    //         console.log(extractedEmails);
    //     } catch (error) {
    //         console.error(error);
    //     }
    // };

    // const convertGoogleSheetUrl = (url) => {
    //     const match = url.match(/\/d\/(.*?)\//);
    //     if (!match) return url;

    //     const sheetId = match[1];
    //     return `https://docs.google.com/spreadsheets/d/${sheetId}/export?format=csv`;
    // };
    // ================= SAVE =================
    const handleAddEmailList = async () => {
        const filteredEmails = emails
            .map((e) => e.trim())
            .filter((e) => e !== "")
            .filter((e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e));

        // ✅ Validation
        if (!emailListName.trim()) {
            Swal.fire({
                icon: "warning",
                title: "List Name Required",
                text: "Please enter email list name."
            });
            return;
        }

        if (filteredEmails.length === 0) {
            Swal.fire({
                icon: "error",
                title: "No Emails Found",
                text: "Please add at least one valid email address."
            });
            return;
        }

        const payload = {
            emailListName,
            marketingFor,
            createdAt,
            emails: filteredEmails,
            totalEmail: filteredEmails.length,
        };

        try {
            if (editId) {
                await axios.put(
                    `${BASE_API_URL}/update/emailList/${editId}`,
                    payload
                );
            } else {
                await axios.post(
                    `${BASE_API_URL}/add/emails`,
                    payload
                );
            }

            Swal.fire({
                icon: "success",
                title: "Saved Successfully",
                timer: 1500,
                showConfirmButton: false
            });

            fetchEmailList();
            handleClose();

        } catch (error) {
            console.error(error);

            Swal.fire({
                icon: "error",
                title: "Save Failed",
                text: "Something went wrong."
            });
        }
    };
    // ================= EDIT =================

    const handleEdit = (item) => {
        setListName(item.emailListName);
        setMarketingFor(item.marketingFor);
        setDate(item.createdAt);

        // ✅ convert array → keep as array (UI handles join)
        setEmailsText(item.emails?.length ? item.emails.join(", ") : "");

        setEditId(item.emailListId);
        setShowModal(true);
    };

    // ================= DELETE =================

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "This email list will be permanently deleted!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
        });

        if (result.isConfirmed) {
            try {
                await axios.delete(`${BASE_API_URL}/delete/emailList/${id}`);

                Swal.fire({
                    title: "Deleted!",
                    text: "Email list has been deleted.",
                    icon: "success",
                    timer: 1500,
                    showConfirmButton: false,
                });

                fetchEmailList();
            } catch (error) {
                console.error("Delete error:", error);

                Swal.fire({
                    title: "Error!",
                    text: "Failed to delete email list.",
                    icon: "error",
                });
            }
        }
    };

    // ================= CLOSE =================
    const handleClose = () => {
        setShowModal(false);
        setEditId(null);
        setListName("");
        setMarketingFor("");
        setDate("");
        setEmailsText("");
    };

    return (
        <div className="p-3 border rounded bg-light">
            <div className="d-flex justify-content-between mb-3">
                <h5>Email Lists</h5>
                <Button onClick={() => setShowModal(true)}>
                    + Add Email List
                </Button>
            </div>

            <Table bordered striped responsive>
                <thead className="table-dark">
                    <tr>
                        <th>Name</th>
                        <th>Total</th>
                        <th>Marketing</th>
                        <th>Date</th>
                        <th>Action</th>
                    </tr>
                </thead>

                <tbody>
                    {emailListData.map((item) => (
                        <tr key={item.emailListId}>
                            <td>{item.emailListName}</td>
                            <td>{item.totalEmail}</td>
                            <td>{item.marketingFor}</td>
                            <td>{item.createdAt}</td>
                            <td>
                                <Button
                                    size="sm"
                                    variant="warning"
                                    className="me-2"
                                    onClick={() => handleEdit(item)}
                                >
                                    Edit
                                </Button>

                                <Button
                                    size="sm"
                                    variant="danger"
                                    onClick={() => handleDelete(item.emailListId)}
                                >
                                    Delete
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            {/* MODAL */}
            <Modal
                show={showModal}
                onHide={handleClose}
                size="lg"
                centered
                contentClassName="border-0 shadow-lg rounded-4"
            >
                <Modal.Header
                    closeButton
                    className="border-0 pb-0"
                    style={{
                       // background: "linear-gradient(135deg, #667eea, #764ba2)",
                        color: "#fff",
                        borderTopLeftRadius: "1rem",
                        borderTopRightRadius: "1rem"
                    }}
                >
                    <Modal.Title className="fw-semibold">
                        ✉️ Add Email List
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="px-4 py-3" style={{ background: "#f8fafc" }}>
                    <Form>

                        {/* ROW 1 */}
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-semibold text-dark">List Name</Form.Label>
                                    <Form.Control
                                        value={emailListName}
                                        onChange={(e) => setListName(e.target.value)}
                                        readOnly={!!editId}
                                        className="rounded-3 shadow-sm border-0"
                                        style={{ background: "#fff" }}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-semibold text-dark">Marketing For</Form.Label>
                                    <Form.Control
                                        value={marketingFor}
                                        onChange={(e) => setMarketingFor(e.target.value)}
                                        className="rounded-3 shadow-sm border-0"
                                        style={{ background: "#fff" }}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* ROW 2 */}
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-semibold text-dark">Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={createdAt}
                                        onChange={(e) => setDate(e.target.value)}
                                        className="rounded-3 shadow-sm border-0"
                                        style={{ background: "#fff" }}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={6} className="d-flex align-items-end">
                                <div
                                    className="w-100 p-3 rounded-3 text-center"
                                    style={{
                                        background: "linear-gradient(135deg, #e0e7ff, #f0f4ff)",
                                        border: "1px solid #dbeafe",
                                        height: "42px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}
                                >
                                    <strong style={{ color: "#4f46e5" }}>
                                        Total Emails: {emails.length}
                                    </strong>
                                </div>
                            </Col>
                        </Row>

                        {/* ROW 3 - TEXTAREA */}
                        {/* <Form.Group className="mb-3">
                            <Form.Label className="fw-semibold text-dark">
                                Emails (comma separated)
                            </Form.Label>

                            <Form.Control
                                as="textarea"
                                rows={4}
                                value={emails.join(", ")}
                                onChange={(e) => setEmails(e.target.value.split(","))}
                                className="rounded-3 shadow-sm border-0"
                                style={{
                                    background: "#fff",
                                    resize: "vertical",
                                    minHeight: "120px",
                                    maxHeight: "400px",
                                    overflowY: "auto"
                                }}
                            />
                        </Form.Group> */}
                        <Form.Group className="mb-3">
    <Form.Label className="fw-semibold text-dark">
        Emails (comma separated)
    </Form.Label>

    <Form.Control
        as="textarea"
        rows={4}
        value={emailsText}
        onChange={(e) => setEmailsText(e.target.value)}
        placeholder="e.g. john@company.com, jane@company.com"
        className="rounded-3 shadow-sm border-0"
        style={{
            background: "#fff",
            resize: "vertical",
            minHeight: "120px",
            maxHeight: "400px",
            overflowY: "auto",
        }}
    />

    {/* Live feedback so users can see it's parsing correctly */}
    <div className="d-flex justify-content-between mt-1">
        <small className="text-muted">
            Separate multiple emails with commas
        </small>
        <small className="fw-semibold" style={{ color: "#4f46e5" }}>
            {emails.length} email{emails.length !== 1 ? "s" : ""} detected
        </small>
    </div>
</Form.Group>

                        {/* OR DIVIDER */}
                        <div className="text-center my-3 position-relative">
                            <hr />
                            <span
                                style={{
                                    position: "absolute",
                                    top: "-12px",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    background: "#f8fafc",
                                    padding: "0 12px",
                                    color: "#6b7280",
                                    fontWeight: "500"
                                }}
                            >
                                OR
                            </span>
                        </div>

                        {/* ROW 4 - FILE UPLOAD */}
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-semibold text-dark">
                                Upload Excel File
                            </Form.Label>
                            <Form.Control
                                type="file"
                                accept=".xlsx,.xls,.csv"
                                onChange={handleExcelUpload}
                                className="rounded-3 shadow-sm border-0"
                                style={{ background: "#fff", cursor: "pointer" }}
                            />
                        </Form.Group>

                    </Form>
                </Modal.Body>

                <Modal.Footer className="border-0 px-4 pb-4" style={{ background: "#f8fafc" }}>
                    <Button
                        variant="light"
                        onClick={handleClose}
                        className="rounded-pill px-4 shadow-sm"
                    >
                        Cancel
                    </Button>

                    <Button
                        onClick={handleAddEmailList}
                        className="rounded-pill px-4 shadow-sm text-white"
                        style={{
                            background: "linear-gradient(135deg, #667eea, #764ba2)",
                            border: "none",
                        }}
                    >
                        💾 Save List
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* GOOGLE SHEET */}
            {/* <Form.Control
                            placeholder="Paste Google Sheet CSV URL"
                            value={googleSheetUrl}
                            onChange={(e) => setGoogleSheetUrl(e.target.value)}
                        />

                        <Button onClick={handleGoogleSheetImport}>
                            Import Sheet
                        </Button> */}
        </div>


    );
};

export default EmailList;